import { Injectable, signal } from '@angular/core';
import { NavItem } from '../models/nav-item.models';

/** Holds the admin `navigation` tree, set via `setNavigation()` by whichever
 * guard/service already fetches `user/v1/me` (see `onboardingGuard`). */
@Injectable({ providedIn: 'root' })
export class NavService {
  private readonly navigation = signal<NavItem[]>([]);

  getNavigation() {
    return this.navigation.asReadonly();
  }

  setNavigation(items: NavItem[]): void {
    this.navigation.set(items);
  }
}
